import { HiOutlineExclamationCircle } from "react-icons/hi";

export default function CustomsInvoiceAlert() {
  return (
    <div className="flex flex-col gap-2 mt-4 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-lg text-sm text-yellow-900 shadow-sm">
      <div className="flex items-start gap-3">
        <HiOutlineExclamationCircle className="w-5 h-5 mt-0.5 flex-shrink-0 text-yellow-600" />
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-yellow-900">
            HS / HTS Code Required
          </span>
          <span className="text-yellow-800">
            You must enter the correct <strong>10-digit HS/HTS code</strong> for
            each item. This information is required for customs clearance.
          </span>
          <a
            href="https://www.canadapost-postescanada.ca/information/app/wtz/business/findHsCode?execution=e1s1"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-block font-medium text-blue-600 underline"
          >
            Find HS / HTS code using Canada Post
          </a>
        </div>
      </div>
    </div>
  );
}